import { gmRequest } from './';

export const sendContactUs = (data) =>
  gmRequest('/api/v1/contact-us', {
    method: 'POST',
    body: JSON.stringify(data),
  });
